import * as React from 'react';
import {
    EditorState,
    convertFromRaw,
    Modifier,
    SelectionState
} from 'draft-js';
import { UilPen } from '@iconscout/react-unicons';
import Popover from 'react-tiny-popover';

import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import MediaManager from '../../../libraries/mediaLibrary/MediaManager';
const FILENAME_REGEX = /\[+[^\]]*\](?!.*\[)/;
const getLabelFromEntity = (label: string) => {
    const arrLabel = label.split('[');
    let mediaURL = '';
    if (arrLabel.length > 1) {
        mediaURL = label.match(FILENAME_REGEX)?.[0];
    }
    return { label: arrLabel[0], mediaURL };
};

const ImagePopover: React.FC<{ imageURL: string }> = ({ imageURL }) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    return (
        <div className="batch-edit--entity--image-modal">
            {/* <MediaManager
                showMediaManager={showMediaManager}
                toggleMediaManager={setShowMediaManager}
            > */}
            <div>
                <img src={`${STATIC_STORAGE_URL}/usr/${imageURL}`} />
                {/* <div
                        className="hover-container"
                        onClick={() => setShowMediaManager(true)}
                    >
                        <div className="hover-container--item">
                            <UilPen size={16} />
                        </div>
                    </div> */}
            </div>
            {/* </MediaManager> */}
        </div>
    );
};

const dynamicText = ({ className, language, editor, editable = false }) => {
    const component = (className, editor, languageeditorState) => {
        return function wrappedComponent({
            entityKey,
            children,
            contentState,
            offsetKey,
            decoratedText,
            ...props
        }) {
            const [showImage, setShowImage] = React.useState(false);
            const [popoverPosition, setPopoverPosition] = React.useState([
                0, 0
            ]);

            const { label, mediaURL } = getLabelFromEntity(decoratedText);

            return (
                <span
                    aria-readonly={true}
                    data-offset-key={offsetKey}
                    className={
                        className ? className : 'dynamic--reference--span'
                    }
                >
                    <span data-offset-key={offsetKey}>
                        <span data-text="true">
                            {/* {decoratedText} */}
                            <span contentEditable={true}>{label}</span>{' '}
                            {mediaURL && (
                                <span>[{mediaURL}]</span>
                                // <Popover
                                //     isOpen={showImage}
                                //     onClickOutside={() => setShowImage(false)}
                                //     padding={10}
                                //     content={
                                //         <ImagePopover imageURL={mediaURL} />
                                //     }
                                //     align="start"
                                //     position="bottom"
                                //     contentLocation={{
                                //         top: popoverPosition[1],
                                //         left: popoverPosition[0]
                                //     }}
                                // >
                                //     <span
                                //         onClick={(e) => {
                                //             setPopoverPosition([
                                //                 e.clientX,
                                //                 e.clientY
                                //             ]);
                                //             setShowImage(true);
                                //         }}
                                //         style={{ cursor: 'pointer' }}
                                //     >
                                //         [{mediaURL}]
                                //     </span>
                                // </Popover>
                            )}
                        </span>
                    </span>
                </span>
            );
        };
    };
    return {
        strategy: findDynamicTextEntities,
        component: component(className, editor, language)
    };
};

function findDynamicTextEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return (
            entityKey !== null &&
            ['BATCH_EDIT'].includes(contentState.getEntity(entityKey).getType())
        );
    }, callback);
}

export const getDecorators = (config) => dynamicText(config);
